module.exports = __webpack_public_path__ + "img/collect_icon_01.bf4635ea.png";